import { API } from "./api";

export function getSid() {
  let sid = localStorage.getItem("tz_sid");
  if (!sid) {
    sid = "v_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("tz_sid", sid);
  }
  return sid;
}

export function trackPage(page) {
  fetch(`${API}/analytics/track`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ sid: getSid(), page }),
  }).catch(() => {});
}

export function heartbeat() {
  fetch(`${API}/analytics/heartbeat`, { method: "POST", credentials: "include" }).catch(() => {});
}
